module.exports = __webpack_public_path__ + "img/Patch10-1.6aa0df5c.webp";